import { StaffService } from '@/services/staff.service'

const CACHE_TIME = 30 * 60 * 1000 // 30 minutes in ms
const RELOGIN_TIME = 24 * 60 * 60 * 1000 // 1 day in ms (24 hours)
const MAX_RETRY = 3 // Số lần tối đa sử dụng cache nếu API lỗi

const encodeJWT = data => {
  try {
    const header = btoa(JSON.stringify({ alg: 'none', typ: 'JWT' }))
    // eslint-disable-next-line no-undef
    const payload = btoa(unescape(encodeURIComponent(JSON.stringify(data)))) // Unicode safe
    const signature = 'crm_nextpay'
    return `${header}.${payload}.${signature}`
  } catch (e) {
    return ''
  }
}

const decodeJWT = token => {
  try {
    const parts = token.split('.')
    if (parts.length !== 3) return null
    // eslint-disable-next-line no-undef
    const payload = decodeURIComponent(escape(atob(parts[1])))
    return JSON.parse(payload)
  } catch (e) {
    return null
  }
}

// Helper to get formatted time in GMT+7 for audit/marking
const getGMT7String = timestamp => {
  return new Date(timestamp).toLocaleString('vi-VN', { timeZone: 'Asia/Ho_Chi_Minh' })
}

export default {
  async fillRoleByUser({ commit, state }) {
    const stored = localStorage.getItem('dataPermission')
    let cachedData = null
    let isExpired = true
    let decoded = null

    if (stored) {
      decoded = decodeJWT(stored)
      if (decoded && decoded.permissions) {
        cachedData = decoded.permissions
        const now = new Date().getTime()
        const timestamp = decoded.timestamp || 0

        // Trường hợp người dùng login quá 1 ngày thì coi như là bị logout
        if (now - timestamp > RELOGIN_TIME) {
          localStorage.removeItem('dataPermission')
          return false
        }

        // Kiểm tra sau 30 phút mới cho gọi lại API
        if (now - timestamp < CACHE_TIME) {
          isExpired = false
        }
      }
    }

    // Nếu quyền còn hạn trong localStorage (chưa quá 30p) thì dùng luôn
    if (!isExpired && cachedData && !state.dataPermission) {
      commit('SET_PERMISSION_BY_USER', cachedData)
      return true
    }

    // Hàm xử lý fallback khi API lỗi hoặc không có dữ liệu
    const handleRetryFallback = () => {
      if (cachedData) {
        const retryCount = (decoded ? decoded.retryCount || 0 : 0) + 1

        // Nếu đã thử 3 lần mà vẫn lỗi/không có dữ liệu thì đẩy về 403
        if (retryCount >= MAX_RETRY) {
          localStorage.removeItem('dataPermission')
          return false
        }

        // Cập nhật số lần retry vào localStorage
        const now = new Date().getTime()
        const updatedJWT = encodeJWT({
          ...decoded,
          retryCount,
          timeMark: getGMT7String(now) + ` (Retry ${retryCount}/${MAX_RETRY})`,
        })
        localStorage.setItem('dataPermission', updatedJWT)

        commit('SET_PERMISSION_BY_USER', cachedData)
        return true
      }
      return false
    }

    try {
      const user = await StaffService.fillPermissionByUser()
      if (user.message === 'Success' && user.data && user.data.permissionCodes) {
        const permissions = user.data.permissionCodes
        commit('SET_PERMISSION_BY_USER', permissions)

        const now = new Date().getTime()
        const jwtString = encodeJWT({
          permissions,
          timestamp: now,
          timeMark: getGMT7String(now), // Đánh dấu theo giờ GM +7
          retryCount: 0, // Reset số lần retry khi thành công
        })
        localStorage.setItem('dataPermission', jwtString)
        return true
      }

      // Trường hợp nếu gọi mà trả về không có dữ liệu
      return handleRetryFallback()
    } catch (error) {
      // Trường hợp API bị lỗi (Network/Server)
      return handleRetryFallback()
    }
  },
  clear({ commit }) {
    commit('CLEAR')
  },
}
